export default [
	{
		path: '/pages/assets/leasingAnalysis',
		meta: { title: '租赁分析' },
		name: '/pages/assets/leasingAnalysis',
		component: () => import('@/views/assets/leasingAnalysis.vue'),
	},
	{
		path: '/pages/assets/leaseControlMap',
		meta: { title: '租控图' },
		name: '/pages/assets/leaseControlMap',
		component: () => import('@/views/assets/leaseControlMap.vue'),
	},
	{
		path: '/pages/assets/rentControlChart',
		meta: { title: '租控台账' },
		name: '/pages/assets/rentControlChart',
		component: () => import('@/views/assets/rentControlChart.vue'),
	},
	{
		path: '/pages/assets/occupancyMap',
		meta: { title: '租赁合同' },
		name: '/pages/assets/occupancyMap',
		component: () => import('@/views/assets/occupancyMap.vue'),
	},
	{
		path: '/pages/assets/collectionPlan',
		meta: { title: '收款计划' },
		name: '/pages/assets/collectionPlan',
		component: () => import('@/views/assets/collectionPlan.vue'),
	},
	{
		path: '/pages/assets/paymentPlan',
		meta: { title: '支付计划' },
		name: '/pages/assets/paymentPlan',
		component: () => import('@/views/assets/paymentPlan.vue'),
	},
	{
		path: '/pages/assets/transactionRecord',
		meta: { title: '交易流水' },
		name: '/pages/assets/transactionRecord',
		component: () => import('@/views/assets/transactionRecord.vue'),
	},
	{
		path: '/pages/assets/financeAnalysis',
		meta: { title: '财务分析' },
		name: '/pages/assets/financeAnalysis',
		component: () => import('@/views/assets/financeAnalysis.vue'),
	},
	{
		path: '/pages/assets/writeOffDetails',
		meta: { title: '销账明细' },
		name: '/pages/assets/writeOffDetails',
		component: () => import('@/views/assets/writeOffDetails.vue'),
	},
	{
		path: '/pages/assets/expenseLedger',
		meta: { title: '费用台账' },
		name: '/pages/assets/expenseLedger',
		component: () => import('@/views/assets/expenseLedger.vue'),
	},
	{
		path: '/pages/assets/budgetManagement',
		meta: { title: '预算管理' },
		name: '/pages/assets/budgetManagement',
		component: () => import('@/views/assets/budgetManagement.vue'),
	},

	{
		path: '/pages/assets/test',
		meta: { title: 'test' },
		name: '/pages/assets/test',
		component: () => import('@/views/assets/transactionRecord.vue'),
	},
];
